import { render, staticRenderFns } from "./InputProfilePermissionForm.vue?vue&type=template&id=b23fa724"
import script from "./InputProfilePermissionForm.vue?vue&type=script&lang=js"
export * from "./InputProfilePermissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports